//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$NewsletterController_syncStatus,
  Response$NewsletterController_syncStatus$Status$200,
  ResponseContentType$NewsletterController_syncStatus,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useNewsletterController_syncStatus = (options: {
  params: Params$NewsletterController_syncStatus['parameter'];
  config?: QueryOptions<
    Response$NewsletterController_syncStatus$Status$200[ResponseContentType$NewsletterController_syncStatus]
  >;
}) =>
  useApiClient<
    Params$NewsletterController_syncStatus,
    Response$NewsletterController_syncStatus$Status$200[ResponseContentType$NewsletterController_syncStatus]
  >({
    method: 'NewsletterController_syncStatus',
    params: { parameter: options.params },
    config: options.config,
  });
